<template>
  <main class="shootlist">
    <SimpleHeader route="/main">
      <template v-slot:title>
        <span>{{$ml.get('מדברים בכיף')}}</span>
      </template>
      <span slot="additional">
        <sidebar-toggler />
        <router-link :to="'/'" class="home-anchor" style="color: white;">
          <svg
                    width="22"
                    height="20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="position:absolute; top: 4px; right: 24px;"
                  >
                    <path
                      d="M10.3312 0.926701L10.2632 0.863573L10.1951 0.926701L0.931976 9.52313L0.85877 9.59106L0.926614 9.66436L1.78441 10.591L1.85245 10.6645L1.92585 10.5964L2.59093 9.9786V17V17.1H2.69093H9.00112H9.10112V17V10.7907H11.4252V17V17.1H11.5252H17.8354H17.9354V17V9.9786L18.6005 10.5964L18.6739 10.6645L18.7419 10.591L19.5997 9.66436L19.6675 9.59106L19.5943 9.52313L10.3312 0.926701ZM16.4733 8.6246V15.6381H12.8872V9.42883V9.32883H12.7872H7.73908H7.63908V9.42883V15.6381H4.05297V8.6246L10.2632 2.85187L16.4733 8.6246Z"
                      fill="white"
                      stroke="white"
                      stroke-width="0.2"
                    />
                  </svg>
        </router-link>
      </span>
    </SimpleHeader>

    <app-loading v-if="!data.length" :loading="false" class="sm-cont" style="position:relative">
      <div style="position:relative; padding: 3px 5px; border-radius: 4px; max-height: 540px !important; margin-top: 33px;">
        <div style="position: absolute;width: 110px !important;top: -23px;right: 16px;z-index: 9999;" class="line h17 w40 m10"></div>
        <div class="btn-skelet" style="position: absolute;left: 12px;bottom: 61px;"></div>
              <div class="btn-skelet" style="position: absolute;right: 12px;bottom: 61px;"></div>
              <div class="btn-skelet-circle" style="position: absolute;bottom: 61px; right: 0;left: 0;margin-left: auto;margin-right: auto;"></div>
              <div
                class="card-wrapper"
                id="playlist_cards_container"
                style="height: 691px;"
              >
              <div class="icon-wrapper">
                    <div class="circle"></div>
                  </div>
                  <div class="icon-wrapper" style="margin-top:10px; height: 224px;">
                    <div class="circle"></div>
                  </div>
                </div>
              </div>
    </app-loading>
    <app-loading v-else class="sm-cont" >
      <template v-if="!!data.length">
        <button  class="settings" @click="$router.push('/shootlist-options')">
          <div style="display: flex;flex-direction: row;" :style="{direction:direction}" class="wrap-loc">
            
            <div style="position:relative; padding: 4px 0px 4px 0px !important;width: 180px; background: #06364B; border-radius: 16px;">
            <svg style="position:absolute; right: 7px; top:4px" width="16" height="19" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.7123 8.795C13.7123 8.55376 13.7891 8.23576 13.7891 7.99452C13.8033 7.72536 13.7774 7.45559 13.7123 7.19404L15.39 5.9988C15.435 5.96964 15.4731 5.93114 15.5018 5.88592C15.5305 5.8407 15.5492 5.78982 15.5564 5.73675C15.5637 5.68368 15.5595 5.62967 15.544 5.57838C15.5286 5.5271 15.5022 5.47975 15.4668 5.43956L13.8658 2.64337C13.8541 2.59325 13.8314 2.54633 13.7995 2.50594C13.7676 2.46555 13.7272 2.43268 13.6812 2.40966C13.6351 2.38664 13.5845 2.37403 13.5331 2.37273C13.4816 2.37142 13.4305 2.38146 13.3834 2.40212L11.4644 3.27937C11.0322 2.93641 10.547 2.66605 10.0279 2.47888L9.78669 0.395444C9.78989 0.34277 9.78187 0.290015 9.76316 0.240669C9.74446 0.191324 9.71548 0.146513 9.67816 0.109198C9.64085 0.0718827 9.59603 0.0429138 9.54669 0.0242078C9.49734 0.00550176 9.44459 -0.00251464 9.39191 0.000686772H6.19001C6.13734 -0.00251464 6.08459 0.00550176 6.03524 0.0242078C5.9859 0.0429138 5.94108 0.0718827 5.90376 0.109198C5.86645 0.146513 5.83747 0.191324 5.81877 0.240669C5.80006 0.290015 5.79204 0.34277 5.79524 0.395444L5.554 2.39116C5.04145 2.59238 4.55829 2.86162 4.11752 3.19164L2.19857 2.39116C2.11195 2.35477 2.01499 2.35142 1.92607 2.38173C1.83715 2.41205 1.76243 2.47393 1.71608 2.55564L0.115133 5.35184C-0.0493491 5.59308 -0.0493411 5.83432 0.191899 5.91108L1.88059 7.22693C1.88059 7.46817 1.80383 7.78617 1.80383 8.02741C1.7896 8.29657 1.81548 8.56634 1.88059 8.82789L0.202842 10.0231C0.157907 10.0523 0.119788 10.0908 0.0910724 10.136C0.0623564 10.1812 0.0437433 10.2321 0.0364592 10.2852C0.0291752 10.3382 0.033404 10.3923 0.0488743 10.4435C0.0643447 10.4948 0.0906931 10.5422 0.126109 10.5824L1.72706 13.3566C1.73882 13.4068 1.76147 13.4537 1.79338 13.4941C1.8253 13.5344 1.8657 13.5673 1.91175 13.5903C1.95779 13.6134 2.00836 13.626 2.05982 13.6273C2.11129 13.6286 2.16239 13.6185 2.20954 13.5979L4.1285 12.7206C4.56075 13.0636 5.04591 13.3339 5.56497 13.5211L5.80622 15.6046C5.80301 15.6572 5.81104 15.71 5.82974 15.7593C5.84845 15.8087 5.87742 15.8535 5.91474 15.8908C5.95205 15.9281 5.99684 15.9571 6.04619 15.9758C6.09553 15.9945 6.14828 16.0025 6.20096 15.9993H9.40289C9.45556 16.0025 9.50832 15.9945 9.55766 15.9758C9.60701 15.9571 9.65183 15.9281 9.68914 15.8908C9.72646 15.8535 9.75543 15.8087 9.77414 15.7593C9.79285 15.71 9.80083 15.6572 9.79763 15.6046L10.0389 13.5211C10.5514 13.3199 11.0346 13.0507 11.4754 12.7206L13.3943 13.5979C13.481 13.6343 13.5779 13.6376 13.6668 13.6073C13.7557 13.577 13.8304 13.5151 13.8768 13.4334L15.4778 10.6372C15.5237 10.5473 15.541 10.4455 15.5272 10.3455C15.5135 10.2455 15.4695 10.1521 15.401 10.078L13.7123 8.795ZM7.79096 11.1964C7.15768 11.1964 6.53864 11.0086 6.01209 10.6568C5.48553 10.305 5.07513 9.80491 4.83278 9.21984C4.59044 8.63477 4.52702 7.99097 4.65057 7.36985C4.77412 6.74874 5.07906 6.17822 5.52686 5.73042C5.97466 5.28262 6.54518 4.97767 7.16629 4.85412C7.7874 4.73057 8.43121 4.79399 9.01628 5.03633C9.60136 5.27868 10.1014 5.68907 10.4533 6.21563C10.8051 6.74218 10.9929 7.36124 10.9929 7.99452C10.99 8.84283 10.6517 9.65557 10.0519 10.2554C9.45201 10.8553 8.63928 11.1935 7.79096 11.1964Z" fill="white"/>
            </svg>
            <span class="open" style="margin-right: 20px;">
              {{$ml.get('הגדרת שאלות ומשתתפים')}}
            </span>
            </div>


            <div style="padding: 4px 5px 4px 0px; width: 204px; text-overflow: ellipsis;overflow: hidden; white-space: nowrap;" v-if="categories.length" class="rest loc-div">
              <span class="locations">{{ categories }}</span>
            </div>
          </div>
        </button>
        <HelpPopup v-if="checkBubble" keyValue="shootlistFirstTime" class="help-element" />
        <div
          class="questions-container"
          id="shootlist_games_container"
          @mousedown="onMouseDown"
          @touchstart="onMouseDown"
        >
          <ShootlistItem
            v-for="(item, i) in data"
            :first="i == data.length - 1"
            ref="questions"
            :key="item.id_shootlist + '-' + item.order_index"
            :question="item"
          />
        </div>

        <PlayersSpinner
          v-if="settings && settings.names.length"
          :num="settings.names.length"
          :names="settings.names"
        />

        <div class="buttons" dir="rtl">
          <!-- <app-btn 
            class="next" 
            @click="next(false)"
            icon="done"
          >
            <span :style="direction==='rtl'? '' : ' font-size: 13px;'" >{{$ml.get('ענינו')}}</span>
          </app-btn> -->
          
          <app-btn class="next" @click="next(false)">
            <div style="width: 100%; position: relative;" >
              <span style="margin-right: 8px;" :style="direction==='rtl'? '' : ' font-size: 13px;'" >{{$ml.get('ענינו')}}</span>
              <svg style="position: absolute; top: 0px; right: -19px;" height="20" viewBox="0 0 48 48" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h48v48h-48z" fill="none"/><path d="M18 32.34l-8.34-8.34-2.83 2.83 11.17 11.17 24-24-2.83-2.83z"/></svg>


            </div>
          </app-btn>

          <LikeButton @click="like" :item="currentItem"/>

          <!-- <app-btn 
            class="prev" 
            @click="skip(false)"
            icon="close"
          >
            <span  :style="direction==='rtl'? '' : ' font-size: 13px;'" >{{$ml.get('לא ענינו')}}</span>
          </app-btn> -->
          <app-btn class="prev" @click="skip(false)">
            <div style="width: 100%; position: relative;" >
              <span style="margin-right: 0px;" :style="direction==='rtl'? '' : ' font-size: 13px;'" >{{$ml.get('לא ענינו')}}</span>
              <svg style="position: absolute; top: 5px; right: -19px;" width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.59376 1L1.59375 9" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
              <path d="M1.59375 1L9.59376 9" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
              </svg>

            </div>

          </app-btn>
        </div>

        

        <!-- <GameIdea
          hidden
          :user="currentItem.user"
          :school="currentItem.school"
          :city="currentItem.city"
          route="/requests/shootlist"
        /> -->
      </template>
    </app-loading>
    <div v-if="!data.length" class="bottom-skelet"></div>
    <AddYourGame v-else :shootlist="false" />
  </main>
</template>

<script>
import LikePopup from "@/components/shootlist/LikePopup";
import ShootlistItem from "@/components/shootlist/ShootlistItem";
import PlayersSpinner from "@/components/shootlist/PlayersSpinner";
import GameIdea from "@/components/GameIdea";
import SimpleHeader from "@/components/SimpleHeader";
import SidebarToggler from "@/components/SidebarToggler";
import LikeButton from "@/components/shootlist/LikeButton";
import AddYourGame from "@/components/shootlist/AddYourGame";
import NoQuestionsFound from "@/components/modals/NoQuestionsFound.vue";
import Subscribe from "@/components/modals/Subscribe.vue";
import SuggestQuestionVue from "@/components/modals/SuggestQuestion.vue";
import { mapGetters } from 'vuex';
import { ShootlistAPI } from "@/api";
import HelpPopup from "@/components/shootlist/HelpPopup";
import store from "@/store";
import DefaultUserInactiveVue from '@/components/modals/defaultUser/DefaultUserInactive.vue';
import DefaultUserToRegVue from '@/components/modals/defaultUser/DefaultUserToReg.vue';
 export default {
  data() {
    return {
      index: 1,
      loading: false,
    };
  },
  components: {
    ShootlistItem,
    PlayersSpinner,
    GameIdea,
    SimpleHeader,
    SidebarToggler,
    LikeButton,
    AddYourGame,
    HelpPopup,
    LikePopup,
    SuggestQuestionVue
  },
  computed: {
   
    ...mapGetters({
      data: 'shootlist/data',
      orderIndex: 'shootlist/orderIndex',
      category: 'shootlist-categories/data',
      settings: 'shootlist/settings',
      count: 'shootlist/count',
      random: 'shootlist/random',
      currentItem: 'shootlist/currentItem',
      categoriesShootlist: 'shootlist-categories/data',
      shootlistCount: "counter-game/getShootlistCount",
      playlistCounter: "user/getPlaylistCounter",
      shootlistCounter: "user/getShootlistCounter",
      isDefaultUser: "user/getDefaultUser",
      playlistDefaultCount :"userDefault/getDefaultUserTotalPL",
      playlistDefaultCurrentCount:"userDefault/getDefaultUserCurrentPL",
      shootlistDefaultCount:"userDefault/getDefaultUserTotalSL",
      shootlistDefaultCurrentCount:"userDefault/getDefaultUserCurrentSL"
    }),
    checkBubble(){
      if(!this.isDefaultUser)
      {
        if(this.shootlistCount>=6)
        {
          return true;
        }
      }
      else if(this.isDefaultUser)
      {
        if(this.shootlistDefaultCurrentCount>=6)
        {
          return true;
        }
      }
      return false;
    },
    direction(){
      return this.$store.getters['lang-store/direction'];
    },
    categories(){
    if(this.settings.categories!=null && this.settings.categories.length>0)
    {
      return this.categoriesShootlist
          .filter(n => this.settings.categories.find(z => z === n.id))
          .map(n => this.translated(n.translation) !=="" && this.translated(n.translation) !==null ? this.translated(n.translation) : n.translation[0].data.name  )
          .join(', ') || '';
    }
    else
    {
      let ids = [];
      this.categoriesShootlist.forEach(element => {
        if(element.is_default == true)
        {
          ids.push(element.id)
        }
      });
      
      this.$store.commit('shootlist/setCategories', ids);
      ShootlistAPI.saveSettings(this.$store.getters['shootlist/settings']).then(()=>{});
      return this.categoriesShootlist.map(n => this.translated(n.translation) !=="" ? this.translated(n.translation) : n.translation[0].data.name  )
          .join(', ') || '';
    }
    }
  },
  methods: {
    translated(translate){
      if (this.$store.getters['lang-store/data']){
        return translate.find(item=>{
          if(this.$store.getters['lang-store/data']=='eng')
            {
              return item.langKey === "en"
            }
            else
            {
            return item.langKey === this.$store.getters['lang-store/data']
            }
        }).data.name
      }
    },
    getCurrentEl() {
      const cards = document.querySelectorAll('#shootlist_games_container .shootlist-item');
      return cards[cards.length - 1]
    },

    getNextEl() {
      const cards = document.querySelectorAll('#shootlist_games_container .shootlist-item');
      return cards[cards.length - 2]
    },

    onMouseDown(e) {
      if (!this.currentItem || this.loading  || this.animating) return;

      var el = this.getCurrentEl();

      if (this.animating) return;

      el.classList.add("grapped");
      this.grapped = true;
      this.starting_x = e.x ? e.x : e.touches[0].clientX;

      document.addEventListener("mousemove", this.onMouseMove);
      document.addEventListener("touchmove", this.onMouseMove);

      document.addEventListener("mouseup", this.onMouseUp);
      document.addEventListener("touchend", this.onMouseUp);
    },

    onMouseMove(e) {
      // сделать кеширование селекторов
      if (!this.grapped) return;

      const el = this.getCurrentEl();

      var offset = (e.x ? e.x : e.touches[0].clientX) - this.starting_x;

      var translate = offset.map(0, el.offsetWidth, 0, 100);
      var rotate = offset.map(0, el.offsetWidth, 0, 60);
      el.style.transform = `translateX(${translate}%) rotate(${rotate}deg)`;

      var side = translate > 0 ? "left" : "right";
      var opacity = Math.abs(offset.map(0, el.offsetWidth / 2, 0, 1));
      e.preventDefault();
    },

    async onMouseUp(e) {
      if (!this.grapped) return;

      var el = this.getCurrentEl();

      el.classList.remove("grapped");
      el.classList.add("swiping");
      var offset = (e.x ? e.x : e.changedTouches[0].clientX) - this.starting_x;
      var percentage = offset.map(0, el.offsetWidth, 0, 100);
      var side = percentage > 0 ? "left" : "right";
      percentage = Math.abs(percentage);

      this.animating = true;
      this.grapped = false;

      setTimeout(() => {
        this.animating = false;
        if (percentage < 50) {
          el.classList.remove("swiping", "swipe-right", "swipe-left");
        } else {
          this.$store.commit('shootlist/deleteLastCard');
        }
      }, 1000);

      if (percentage >= 50) {
        if(this.$store.getters["user/isLoaded"])
      {
        let num = localStorage.getItem('shootlist_freq')?localStorage.getItem('shootlist_freq'):0;
        if(num<=0)
        {
          localStorage.setItem('shootlist_freq', 1);
        }
        else
        {
          localStorage.setItem('shootlist_freq', parseInt(num)+1);
          if(parseInt(num)+1>=this.$store.getters["user/data"].frequency.shootlist)
          {
            localStorage.removeItem('shootlist_freq');
            this.$modal.show(
      SuggestQuestionVue,
            {},
            {
              height: "auto",
              adaptive: true,
              width: 360,
            }
          );
          }
        }
      }
        if (side == "left") {
          el.classList.add("swipe-left");
          this.setViewed();
          await this.$store.dispatch('shootlist/throwActivity', 'ans').then(async ()=>{
            if(!this.$store.getters["user/checkSubs"] && this.$store.getters["user/data"].subscribe_shootlist>0)
          {
          this.$store.commit('user/decreaseSubsShootlistCounter');
          if(this.shootlistCount<7)
            {
              this.$store.commit('counter-game/increaseShootlist');
            }
          await this.getRandomTotalShootlist();
          }
          else if(!this.$store.getters["user/checkSubs"])
          {
            this.$store.dispatch('user/decreaseShootlistCounter');
            this.$store.commit('shootlist/increaseShootlistPassedCounter');
            if(this.shootlistCount<7)
            {
              this.$store.commit('counter-game/increaseShootlist');
            }
            await this.getRandom({
            neededCheck: true
          });
          }
          else
          {
            if(this.shootlistCount<7)
            {
              this.$store.commit('counter-game/increaseShootlist');
            }
            await this.getRandom({
            neededCheck: false
          });
          }
          });
        } else {
          el.classList.add("swipe-right");
          this.setViewed();
          await this.$store.dispatch('shootlist/throwActivity', 'skp').then(async()=>{
          if(!this.$store.getters["user/checkSubs"] && this.$store.getters["user/data"].subscribe_shootlist>0)
          {
          this.$store.commit('user/decreaseSubsShootlistCounter');
          if(this.shootlistCount<7)
            {
              this.$store.commit('counter-game/increaseShootlist');
            }
          await this.getRandomTotalShootlist();
          }
          else if(!this.$store.getters["user/checkSubs"])
          {
            this.$store.dispatch('user/decreaseShootlistCounter');
            this.$store.commit('shootlist/increaseShootlistPassedCounter');
            if(this.shootlistCount<7)
            {
              this.$store.commit('counter-game/increaseShootlist');
            }
            await this.getRandom({
            neededCheck: true
          });
          }
          else
          {
            if(this.shootlistCount<7)
            {
              this.$store.commit('counter-game/increaseShootlist');
            }
            await this.getRandom({
            neededCheck: false
          });
          }
          });
        }
      } else {
        el.style.transform = "translateX(0) rotate(0)";
      }
      document.removeEventListener("mousemove", this.onMouseMove);
      document.removeEventListener("touchmove", this.onMouseMove);
      document.removeEventListener("mouseup", this.onMouseUp);
      document.removeEventListener("touchend", this.onMouseUp);
    },
    setViewed(){
      this.$store.commit('shootlist/pushViewed',this.data[0].id_shootlist);
      if(this.isDefaultUser)
      {
        this.addLocalStore();
      }
    },
    addLocalStore()
    {
      let arr = localStorage.getItem('shootlists_before_reg');
      if(arr!=null && arr.length>0)
      {
        arr=arr.split(',')
        arr.push(this.data[0].id_shootlist);
        localStorage.setItem('shootlists_before_reg',arr);
      }
      else
      {
        let newArr = [];
        newArr.push(this.data[0].id_shootlist);
        localStorage.setItem('shootlists_before_reg',newArr);
      }
    },
    async next(swipe = true) {
      window.fbq('track','Play questions');
      let el = this.getCurrentEl();
      
      // TODO: ref.advertisment
      if (this.loading  || this.animating) {
        return;
      }
      

      this.animating = true;
      el.classList.add("animate", "animate-left");
      setTimeout(() => {
        this.animating = false;
        this.$store.commit('shootlist/deleteLastCard');
      }, 2000);

      this.setViewed();
      if(this.$store.getters["user/isLoaded"])
      {
        let num = localStorage.getItem('shootlist_freq')?localStorage.getItem('shootlist_freq'):0;
        if(num<=0)
        {
          localStorage.setItem('shootlist_freq', 1);
        }
        else
        {
          localStorage.setItem('shootlist_freq', parseInt(num)+1);
          if(parseInt(num)+1>=this.$store.getters["user/data"].frequency.shootlist)
          {
            localStorage.removeItem('shootlist_freq');
            this.$modal.show(
      SuggestQuestionVue,
            {},
            {
              height: "auto",
              adaptive: true,
              width: 360,
            }
          );
          }
        }
      }
      await this.$store.dispatch('shootlist/throwActivity', 'ans').then( async res=>{
        if(res==true)
        {
          this.$store.dispatch('user/decreaseShootlistCounter');
          if(this.shootlistCount<7)
            {
              this.$store.commit('counter-game/increaseShootlist');
            }
         if(!this.$store.getters["user/checkSubs"] && this.$store.getters["user/data"].subscribe_shootlist>0)
          {
          this.$store.commit('user/decreaseSubsShootlistCounter');
          await this.getRandomTotalShootlist();
          }
          else if(!this.$store.getters["user/checkSubs"])
          {
            this.$store.commit('shootlist/increaseShootlistPassedCounter');
            await this.getRandom({
            neededCheck: true
          });
          }
          else
          {
            await this.getRandom({
            neededCheck: false
          });
          }
        }
      });
    },

    async skip(swipe = true) {
     
      window.fbq('track','Play questions');
      const el = this.getCurrentEl();
      // TODO: ref.advertisment
      if (this.loading || this.animating) {
        return;
      }
      this.animating = true;
      el.classList.add("animate", "animate-right");
      setTimeout(() => {
        this.animating = false;
        this.$store.commit('shootlist/deleteLastCard');
      }, 2000);
      this.setViewed();
      if(this.$store.getters["user/isLoaded"])
      {
        let num = localStorage.getItem('shootlist_freq')?localStorage.getItem('shootlist_freq'):0;
        if(num<=0)
        {
          localStorage.setItem('shootlist_freq', 1);
        }
        else
        {
          localStorage.setItem('shootlist_freq', parseInt(num)+1);
          if(parseInt(num)+1>=this.$store.getters["user/data"].frequency.shootlist)
          {
            localStorage.removeItem('shootlist_freq');
            this.$modal.show(
      SuggestQuestionVue,
            {},
            {
              height: "auto",
              adaptive: true,
              width: 360,
            }
          );
          }
        }
      }
      await this.$store.dispatch('shootlist/throwActivity', 'skp').then(async res=> {
        if(res==true)
        {
          this.$store.dispatch('user/decreaseShootlistCounter');
          if(this.shootlistCount<7)
            {
              this.$store.commit('counter-game/increaseShootlist');
            }
          if(!this.$store.getters["user/checkSubs"] && this.$store.getters["user/data"].subscribe_shootlist>0)
          {
          this.$store.commit('user/decreaseSubsShootlistCounter');
          await this.getRandomTotalShootlist();
          }
          else if(!this.$store.getters["user/checkSubs"])
          {
            this.$store.commit('shootlist/increaseShootlistPassedCounter');
            await this.getRandom({
            neededCheck: true
          });
          }
          else
          {
            await this.getRandom({
            neededCheck: false
          });
          }
        }
      });
    },

    getRandomTotalShootlist(data = {}) {
      if(this.isDefaultUser && this.shootlistDefaultCount == this.shootlistDefaultCurrentCount)
      {
        this.$router.push('/main');
        this.$modal.show(
          DefaultUserToRegVue,
          {

          },
          {
            adaptive: true,
            height: "auto",
            width: 300
          }
        )
      }
      else
      {
        var id_school = this.$store.getters["user/data"].id_school;
      if ( id_school == null && this.shootlistCounter < 1 && !this.$store.getters["user/checkSubs"] && !this.isDefaultUser && !this.$store.getters['sub/getDisabled']) 
      {
        this.$store.dispatch("user/defaultShootlistCounter");
        this.$store.commit('user/setSub',true);
        this.$router.replace("/subsPlans");
        this.$store.commit("shootlist/setViewed", []);
        this.$store.commit('shootlist/resetShootlistPassedCounter');
        this.$store.dispatch('user/updateData');
        this.$store.commit("shootlist/setViewed", []);
      }
      this.loading = true;
      return this.$store.dispatch('shootlist/getRandom', data)
        .then(res => {
          this.index++;
          if (this.random && !this.popup_showed) {

            this.$modal.show(
                NoQuestionsFound,
                {},
                {
                  height: "auto",
                  width: 300
                }
            );
            this.$store.dispatch('shootlist/setDefaultSettings');
            this.popup_showed = true;
          }
          this.loading = true;
          return res;
          
        })
        .catch(()=>{
          this.$store.dispatch('user/updateData');
          this.$store.commit("shootlist/setViewed", []);
        })
        .finally(() => {
          this.loading = false;
        });
      }
    },

    getRandom(data = {}) {
      if(this.isDefaultUser && this.shootlistDefaultCount == this.shootlistDefaultCurrentCount)
      {
        this.$router.push('/main');
        this.$modal.show(
          DefaultUserToRegVue,
          {

          },
          {
            adaptive: true,
            height: "auto",
            width: 300
          }
        )
      }
      else
      {
      if(data.neededCheck==true)
      {
        var id_school = this.$store.getters["user/data"].id_school;
      if ( id_school == null && this.shootlistCounter < 1 && !this.$store.getters["user/checkSubs"] && !this.isDefaultUser && !this.$store.getters['sub/getDisabled']) 
      {
        this.$store.dispatch("user/defaultShootlistCounter");
        this.$store.commit('user/setSub',true);
        this.$router.replace("/subsPlans");
        this.$store.commit("shootlist/clearStorage");
        this.$store.commit("shootlist/setViewed", []);
        this.$store.commit('shootlist/resetShootlistPassedCounter');
        this.$store.dispatch('user/updateData');
        this.$store.commit("shootlist/setViewed", []);
      }
      }
      this.loading = true;
      return this.$store.dispatch('shootlist/getRandom', data)
        .then(res => {
          this.index++;
          if (this.random && !this.popup_showed) {
            this.$modal.show(
                NoQuestionsFound,
                {},
                {
                  height: "auto",
                  width: 300
                }
            );
            
            this.popup_showed = true;
          }
          this.loading = true;
          return res;
          
        })
        .catch(()=>{
          this.$store.dispatch('user/updateData');
          this.$store.commit("shootlist/setViewed", []);
        })
        .finally(() => {
          this.loading = false;
        });
      }
    },

    like() {
      if(this.isDefaultUser)
      {
        this.$modal.show(
          DefaultUserInactiveVue,
          {

          },
          {
            adaptive: true,
            height: "auto",
            width: 300
          }
        )
      }
      else
      {
      if (!this.currentItem.liked) {
        axios.put(
          "/shootlist/" + this.currentItem.id_shootlist + "/activity/lik"
        );
      }
      this.currentItem.liked = !this.currentItem.liked;
      axios.put("/shootlist/" + this.currentItem.id_shootlist + "/like");
      }
    },

    getState() {
      return this.$store.dispatch('shootlist/getState');
    }
  },
  mounted(){
   
  },
  created() {
    window.fbq("track", "מדברים בכיף");
    // this.$store.commit('shootlist/resetShootlistPassedCounter');
    // this.$store.dispatch['user/updateData'];
    // if(!this.$store.getters["user/checkSubs"]  && this.$store.getters["user/data"].subscribe_shootlist==0)
    // {
    //   this.$store.commit("shootlist/setViewed", []);
    // }
    
   
    if(!Object.keys(this.settings).length) {
      this.$store.dispatch('shootlist/setDefaultSettings');
      this.isDefault = this.category
              .filter(item => item.is_default)
              .map(item => {
                return item.id;
              });
      this.settings.categories = [...new Set(this.isDefault)];
      this.$store.commit('shootlist/setSettings',this.settings);
    }
    const init = async () => {
      await this.$store.commit('shootlist/resetGames');
      await this.$store.dispatch('user/decreaseShootlistCounter');
      if(!this.isDefaultUser)
      {
      await this.getState();
      }
      await this.getRandom({
        id_shootlist: this.$route.params.id_shootlist,
        neededCheck: false
      });
      this.setViewed();
      await this.getRandom();
    };

    if (!this.data.length || this.$route.params.id_shootlist) {
      init();
    }
  },
};
</script>

<style lang="scss" scoped>
 .loc-div{
    width: 204px;
  }
  @media (max-width: 410px){
    .loc-div{
    width: 150px !important;
  }
  }
  @media (max-width: 360px){
    .loc-div{
    width: 110px !important;
  }
  }
.bottom-skelet{
  background: rgba(130, 130, 130, 0.2);
     background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
     background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
     background-size: 800px 100px;
     animation: wave-squares 2s infinite ease-out;
}
.circle {
     min-height: 100%;
     max-height: 100%;
     min-width: 100%;
     max-width: 100%;
     background: rgba(130, 130, 130, 0.2);
     background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
     background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
     background-size: 800px 100px;
     animation: wave-squares 2s infinite ease-out;
}
.btn-skelet{
     background: rgba(130, 130, 130, 0.2);
     background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
     background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
     background-size: 800px 100px;
     animation: wave-squares 2s infinite ease-out;
}
.btn-skelet-circle{
  background: rgba(130, 130, 130, 0.2);
     background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
     background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
     background-size: 800px 100px;
     animation: wave-squares 2s infinite ease-out;
}
.line {
  
  position: absolute;
     height: 12px;
     left: 22px;
     width:100%;
      display:block;
     margin-bottom:6px;
     border-radius: 2px;
     background: rgba(130, 130, 130, 0.2);
     background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
     background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
     background-size: 800px 100px;
     animation: wave-lines 2s infinite ease-out;
}
 
 .flex1{
    flex: 1;
}
 .flex2{
    flex: 2;
}
 .h8{
    height: 8px !important;
}
 .h10{
    height: 10px !important;
}
 .h12{
    height: 12px !important;
}
 .h15{
    height: 15px !important;
}
 .h17{
    height: 17px !important;
}
 .h20{
    height: 20px !important;
}
 .h25{
    height: 25px !important;
}
 .w25{
    width: 25% !important
}
 .w40{
    width:60% !important;
}
 .w50{
    width: 50% !important
}
 .w75{
    width: 75% !important
}
 .m10{
    margin-bottom: 10px !important;
}
 .circle{
  border-radius: 15px !important;
     height: 180px !important;
     width: 100% !important;
}

.btn-skelet{
  border-radius: 9999px !important;
     height: 42px !important;
     width: 140px !important;
}

.btn-skelet-circle{
  border-radius: 9999px !important;
     height: 42px !important;
     width: 40px !important;
}

.bottom-skelet{
  width: 100%;
  height: 70px;
}

 @keyframes wave-lines {
    0% {
        background-position: -468px 0;
    }
     100% {
        background-position: 468px 0;
    }
}
 @keyframes wave-squares {
    0% {
        background-position: -468px 0;
    }
     100% {
        background-position: 468px 0;
    }
}

.shootlist {
  color: #fff;
  background: #00465B;
  padding-bottom: 0 !important;

  display: flex;
  flex-direction: column;

  .settings {
  
  color: #fff;
  font-size: 12px;
  padding: 8px;

  display: flex;
  flex-direction: row;
  align-items: center;
  .locations{
    font-family: 'App';
    font-style: normal;
    font-weight: 200;
    font-size: 14px;
    line-height: 19px;
    /* identical to box height */

    text-align: right;

    color: #FFFFFF;
    // padding-left: 5px;
   margin: 0 5px;
  }

  .open {
    font-family: 'App';
    font-style: normal;
    font-weight: 200;
    font-size: 14px;
    line-height: 19px;
    /* identical to box height */

    text-align: right;

    color: #FFFFFF;
    // padding-left: 5px;
   margin: 0 5px;
    
    svg {
      margin-left: 5px;
    }
  }

  .rest {
    text-align: start;
    // max-width: 150px;
    // text-overflow: ellipsis;
    // overflow: hidden;
    // white-space: nowrap;
  }
}

  .app-loading {
    padding: 0 10px;
    flex-grow: 1;
  } 

  .players-spinner {
    margin: 0 0 17px 0;
  }

  .questions-container {
    margin: 0 0 10px 0;
  }

  .buttons {
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .prev {
      background-color: #ff7384;
      width: 140px;
      span{
        color: #01465B;
      }
    }

    .next {
      background-color: #73cd49;
      width: 140px;
      span{
        color: #01465B;
      }
    }
  }
  .small {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
    padding: 10px 0;

    button {
      position: relative;
      padding: 0;
      color: #fff;
      font-size: 16px;

      &.reply {
        i::before {
          transform: scale(-1, 1);
        }
      }
      i {
        margin: 0 5px;
        font-size: 24px;
        vertical-align: middle;
      }
      svg {
        vertical-align: middle;
        margin: 0 5px;
        margin-bottom: 4px;
      }
    }
  }
  .questions-container {
    z-index: 1;
    position: relative;
    height: 180px;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
  }
}
</style>
